import styled, { createGlobalStyle } from "styled-components";

export default styled.div`
  .menu-layout {
    -webkit-transition: margin-left 200ms ease-in-out;

    .menu-layout-content {
      height: 97vh;
      border-radius: 16px;
      margin-top: 12px;
      margin-bottom: 12px;
      box-shadow: rgba(100, 100, 111, 0.2) 0px 7px 29px 0px;
      background-color: white;
      overflow: scroll;
      position: relative;

      .headermock {
        height: 4rem;
        width: 100%;
      }

      .main-content-container {
        padding: 1rem;
      }

      &--no-scroll {
        overflow: hidden;
      }
    }

    .menu-layout-header {
      position: absolute;
      top: 0px;
      right: 0;
      z-index: 100;
      width: 100%;
      height: fit-content;
      padding-left: 12px;
      padding-right: 12px;
    }

    .menu-layout-footer {
      position: absolute;
      bottom: 0px;
      right: 0;
      z-index: 100;
      width: 100%;
      height: fit-content;
      padding-left: 12px;
      padding-right: 12px;
    }
  }

  @media screen and (max-width: 768px) {
    .drawer-component {
      display: none;
    }

    .menu-layout {
      margin-left: 0px !important;
      height: calc(var(--vh, 1vh) * 100);
      overscroll-behavior: initial;

      .menu-layout-content {
        margin-top: 0px;
        margin-bottom: 0px;
        height: calc(var(--vh, 1vh) * 100);
        border-radius: 0px;

        .main-content-container {
          min-height: 90svh;
          padding: 0.75rem;

          &--header {
            margin-top: 3rem;
          }
        }
        &--no-scroll {
        }
      }

      .menu-layout-header {
        padding-left: 0px;
        padding-right: 0px;
      }

      .menu-layout-footer {
        padding-left: 0px;
        padding-right: 0px;
      }
    }
  }
`;

export const GlobalStyle = createGlobalStyle`

body{
  background-color: rgba(218, 218, 218, 0.3);
}
`;
